import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ExcelProcessor = () => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [idColumn, setIdColumn] = useState('');
  const [clientColumn, setClientColumn] = useState('');
  const [spouseColumn, setSpouseColumn] = useState('');

  // טעינת הקובץ והמרה ל-JSON
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: 'binary' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const headers = jsonData[0];
      const rows = jsonData.slice(1).map((row) =>
        headers.reduce((acc, key, index) => {
          acc[key] = row[index] || ''; // מגדיר ריק אם אין ערך
          return acc;
        }, {})
      );

      setColumns(headers);
      setData(rows);
    };
    reader.readAsBinaryString(file);
  };

  // פונקציית המיפוי והיצירה של עמודת spouseId
  const handleMapping = () => {
    if (!idColumn || !clientColumn || !spouseColumn) {
      alert('נא לבחור את כל העמודות');
      return;
    }

    const updatedData = data.map((row) => ({ ...row, spouseId: row.spouseId || '' })); // יצירה של עמודת spouseId אם לא קיימת

    updatedData.forEach((row) => {
      const spouseIds = updatedData
        .filter(
          (otherRow) =>
            otherRow[clientColumn] === row[spouseColumn] &&
            otherRow[spouseColumn] === row[clientColumn]
        )
        .map((otherRow) => otherRow[idColumn]);

      row.spouseId = [...new Set([...(row.spouseId ? row.spouseId.split(',') : []), ...spouseIds])].join(',');
    });

    setData(updatedData);
    exportToExcel(updatedData);
  };

  // יצירת קובץ אקסל להורדה
  const exportToExcel = (dataToExport) => {
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'UpdatedData.xlsx');
  };

  return (
    <div>
      <p>מסנכרן בין בני זוג</p>
      <input type="file" onChange={handleFileUpload} accept=".xlsx, .xls" />
      {columns.length > 0 && (
        <div>
          <label>
            עמודת זיהוי:
            <select value={idColumn} onChange={(e) => setIdColumn(e.target.value)}>
              <option value="">בחר עמודה</option>
              {columns.map((col) => (
                <option key={col} value={col}>
                  {col}
                </option>
              ))}
            </select>
          </label>
          <label>
            עמודת לקוח:
            <select value={clientColumn} onChange={(e) => setClientColumn(e.target.value)}>
              <option value="">בחר עמודה</option>
              {columns.map((col) => (
                <option key={col} value={col}>
                  {col}
                </option>
              ))}
            </select>
          </label>
          <label>
            עמודת בת זוג:
            <select value={spouseColumn} onChange={(e) => setSpouseColumn(e.target.value)}>
              <option value="">בחר עמודה</option>
              {columns.map((col) => (
                <option key={col} value={col}>
                  {col}
                </option>
              ))}
            </select>
          </label>
          <button onClick={handleMapping}>מיפוי</button>
        </div>
      )}
    </div>
  );
};

export default ExcelProcessor;
